"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardShortcut = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var colors_1 = require("./utils/colors");
/**
 * Displays a keyboard shortcut indicator
 */
var KeyboardShortcut = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "primary" : _b, props = __rest(_a, ["variant"]);
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    return (react_1.default.createElement(Wrapper, __assign({ variant: variant, secondaryThemeColor: secondaryThemeColor }, props),
        react_1.default.createElement(Text_1.Text, { variant: "uiTiny500" }, props.shortcut)));
};
exports.KeyboardShortcut = KeyboardShortcut;
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2px 4px;\n  background: ", ";\n  border-radius: 3px;\n  box-sizing: border-box;\n  min-width: 20px;\n  display: flex;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.04);\n\n  color: ", ";\n\n  ", ";\n"], ["\n  padding: 2px 4px;\n  background: ", ";\n  border-radius: 3px;\n  box-sizing: border-box;\n  min-width: 20px;\n  display: flex;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.04);\n\n  color: ", ";\n\n  ", ";\n"])), theme_1.theme.colors.gold300, function (_a) {
    var variant = _a.variant, secondaryThemeColor = _a.secondaryThemeColor;
    return variant === "primary" ? secondaryThemeColor : theme_1.theme.colors.gray600;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n      background: ".concat(theme_1.theme.colors.gray200, ";\n      color: ").concat(theme_1.theme.colors.gray400, ";\n    ");
});
var templateObject_1;
